(function() {
  // Check if we're on the professional hub page
  if (!window.location.pathname.endsWith('/blogs/professional-hub')) {
    return;
  }

  // Show popup every time
  const popup = document.getElementById('professionalHubPopup');
  if (popup) {
    popup.style.display = 'flex';
  }
})();

// Handle user response
function confirmProfessional(isProfessional) {
  if (isProfessional) {
    // Hide popup
    const popup = document.getElementById('professionalHubPopup');
    if (popup) {
      popup.style.display = 'none';
    }
  } else {
    // Redirect to G-health page
    window.location.href = `${Shopify.routes.root}blogs/g-health`;
  }
}